import axios from 'axios';
import { auth } from '@/firebase/config';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const axiosClient = axios.create({
  baseURL: backendUrl,
  withCredentials: true,
});

// Guard against cascading redirects when multiple concurrent requests all
// get 401/403 at the same time (e.g. Navigation poll + Dashboard poll).
let redirectingToLogin = false;

async function forceLogout() {
  if (redirectingToLogin) return;
  redirectingToLogin = true;
  try {
    await auth.signOut();
  } catch {
    // ignore — signOut may fail if already signed out
  }
  window.location.assign('/login');
}

axiosClient.interceptors.request.use(
  async (config) => {
    const user = auth.currentUser;
    if (user) {
      try {
        const token = await user.getIdToken();
        if (token) {
          config.headers = config.headers ?? {};
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (error) {
        console.error('Failed to refresh Firebase token', error);
      }
    }
    return config;
  },
  (error) => Promise.reject(error),
);

axiosClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;

    // 401 = token invalid / expired.
    // 403 = account not on the ALLOWED_USER_EMAILS allowlist.
    // Both mean the session is unusable — sign out and return to login.
    if (status === 401 || status === 403) {
      forceLogout();
      // Return a never-settling promise so every caller stays suspended
      // while the browser navigates away. This prevents "Dashboard
      // unavailable" from flashing on screen during the redirect.
      return new Promise(() => {});
    }

    return Promise.reject(error);
  },
);

export default axiosClient;




